@if (options) {
  <div class="{{className}}"  [ngClass]="disable === true ? 'disableStar' : ''">
    @for (option of options; track option; let i = $index) {
      <ng-container class="">
        <span class="fa fa-star mr-2 fa-2x" (click)="getCurrentItems(i);" [ngClass]="(option['selected']!=undefined && option['selected']===true)?'checked_star':''"></span>
      </ng-container>
    }
  </div>
}